import cx from 'classnames';
import React from 'react';
import Icon from './Icon';

var SocialIcon = function SocialIcon(_ref) {
  var className = _ref.className,
      service = _ref.service,
      title = _ref.title,
      url = _ref.url;
  var classes = cx('socialIcon', className);
  return React.createElement("a", {
    href: url,
    className: classes,
    title: title,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(Icon, {
    icon: service
  }));
};

export default SocialIcon;